"use client";
import React, { useState } from "react";

import { QuestionCircleOutlined } from "@ant-design/icons";
import { Row, Col, Card, Progress, Popover } from "antd";

import { colorPalet } from "@/lib/colorPalet";
import { HOW_TO_USE } from "@/lib/constants";
import { queLogo, openAILogo } from "@/lib/imageIcon";
import { TOOLTIPS } from "@/lib/tooltip";

import { ModalComponent } from "../modal/page";

const SummaryChart = ({ stockData }) => {
  const [showModal, setShowModal] = useState(false);
  const [toggle, setToggle] = useState({
    watch: false,
    score: false,
    fourm: false,
    mos: false,
  });
  const progressClass =
    stockData?.mosPer <= 40 ? "red-progress-bar" : "green-progress-bar";

  const renderBars = () => (
    <>
      <div className={progressClass}></div>
      <div className={progressClass}></div>
      <div className={progressClass}></div>
    </>
  );

  const barConfigs = [
    { style: { width: "0.8%", marginRight: 5 } },
    { style: { width: "98.4%" } },
    { style: { width: "0.8%", marginLeft: 5 } },
  ];
  const handleFormate = (percent) => {
    return (
      <>
        <div>
          {stockData?.avgFourmScore === 0 ? (
            <>
              <img alt="queLogo" src={queLogo} width={32} height={32} />{" "}
            </>
          ) : (
            <>
              {" "}
              <span className="result-score">{`${percent}`}</span>
              <span className="result-total">/100</span>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="value-row mt-24">
      {showModal && (
        <ModalComponent
          toggle={toggle}
          showModal={showModal}
          setShowModal={setShowModal}
          HOW_TO_USE={HOW_TO_USE}
          setToggle={setToggle}
        />
      )}
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Card className="common-card">
            <div className="card_header d-flex justify-content-between">
              <p className="header-title p-16 pl-0">Summary</p>
              <div className="how-it-works-div cursor-pointer">
                <p
                  className="how-it-works"
                  onClick={() => {
                    setShowModal(true);
                    setToggle({ ...toggle, watch: !toggle.watch });
                  }}
                >
                  How It Works
                </p>
              </div>
            </div>

            <div className="card-body d-flex flex-column align-items-center justify-content-between">
              <div className="pt-50">
                <p className="navigate-link-why text-center max-w-300">
                  Stocks in Tykr are classified as either On Sale, Watch, or
                  Overpriced. Only 15% of stocks achieve an On Sale rating in
                  Tykr.
                </p>

                <div
                  className="d-flex justify-content-center mt-16"
                  onClick={() => {
                    setShowModal(true);
                    setToggle({ ...toggle, watch: !toggle.watch });
                  }}
                >
                  {stockData?.summary && (
                    <div
                      className={`potential_data  ${
                        stockData?.summary === "On Sale"
                          ? "potential_buy potential_onsale"
                          : stockData?.summary === "Watch"
                            ? "potential_hold"
                            : "potential_sell"
                      } `}
                    >
                      <span className="stock-summery">
                        {stockData?.summary}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Card className="common-card">
            <div className="card_header d-flex justify-content-between">
              <p className="header-title p-16 pl-0">Score</p>
              <div className="how-it-works-div cursor-pointer">
                <p
                  className="how-it-works"
                  onClick={() => {
                    setShowModal(true);
                    setToggle({ ...toggle, score: !toggle.score });
                  }}
                >
                  How It Works
                </p>
              </div>
            </div>
            <div className="card-body d-flex flex-column align-items-center justify-content-between">
              <div className="score-data d-flex flex-column align-items-center">
                <div
                  className={`hexagon ${
                    stockData?.summary === "On Sale"
                      ? "_greenHexa"
                      : stockData?.summary === "Watch"
                        ? "_greyHexa"
                        : "_redHexa"
                  }`}
                >
                  <div className="progress">
                    <div className="_subHexagon">
                      <p className="progress-value">
                        {stockData?.newScore || 0}
                        <span>/100</span>
                      </p>
                    </div>
                  </div>
                </div>

                <p className="stock-newScore mt-12 text-center">
                  This stock has a score of{" "}
                  <span>{stockData?.newScore || 0}</span>/100
                </p>
              </div>
            </div>
          </Card>
        </Col>
        {!stockData?.isEtf && (
          <>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card className="common-card fourm-why-card">
                <div className="card_header d-flex justify-content-between">
                  <p className="header-title p-16 pl-0">
                    4M Confidence Booster
                  </p>
                  <div className="how-it-works-div cursor-pointer">
                    <p
                      className="how-it-works"
                      onClick={() => {
                        setShowModal(true);
                        setToggle({ ...toggle, fourm: !toggle.fourm });
                      }}
                    >
                      How It Works
                    </p>
                  </div>
                </div>

                <div className="card-body d-flex flex-column align-items-center justify-content-between min-w-250">
                  <div className="score-data d-flex flex-column align-items-center">
                    <div className="progress-div">
                      <Progress
                        className="result-sppiner"
                        gapDegree={0}
                        strokeWidth={9}
                        type="dashboard"
                        size="large"
                        percent={stockData?.avgFourmScore || 0}
                        format={(percent) => handleFormate(percent)}
                        height="144px"
                        strokeColor={
                          stockData?.avgFourmScore >= 80
                            ? colorPalet.success
                            : stockData?.avgFourmScore >= 60
                              ? colorPalet.textTertiary
                              : colorPalet.error
                        }
                        aria-label="4M Confidence Booster Score"
                      />
                    </div>
                  </div>
                  <p className="header-title d-flex mt-15 align-items-center">
                    Powered by
                    <img
                      alt="OpenAI"
                      src={openAILogo}
                      className="ml-6"
                      width={80}
                      height={20}
                    />
                  </p>
                </div>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card className="common-card">
                <div className="card_header d-flex justify-content-between">
                  <p className="header-title p-16 pl-0">MOS</p>
                  <div className="how-it-works-div cursor-pointer">
                    <p
                      className="how-it-works"
                      onClick={() => {
                        setShowModal(true);
                        setToggle({ ...toggle, mos: !toggle.mos });
                      }}
                    >
                      How It Works
                    </p>
                  </div>
                </div>
                <div className="card-body pt-0 d-flex flex-column align-items-center justify-content-between min-w-250">
                  <div className={`_progreeBar why-stock w-100`}>
                    <div className="progress-bar-slider w-100">
                      <Progress
                        className="progress-bar progress-bar-stocks"
                        strokeLinecap="circle"
                        percent={100 - stockData?.mosPer}
                        format={() => null}
                        aria-label="MOS Score"
                      />
                    </div>
                    <div
                      style={{ width: `${stockData?.mosPer}%` }}
                      className="progress-bar-div d-flex"
                    >
                      {barConfigs.map((config, index) => (
                        <div key={index} style={config.style}>
                          {renderBars()}
                        </div>
                      ))}
                    </div>

                    <div className="d-flex flex-column align-items-center w-100 mt-18">
                      <div className="_safetyBox d-flex justify-content-center">
                        <div className="mobile-current-price">
                          Margin of Safety
                          <Popover
                            content={<p>{TOOLTIPS["mos"]}</p>}
                            title="Margin of Safety"
                          >
                            <QuestionCircleOutlined className="ml-4 cursor-pointer" />
                          </Popover>
                        </div>
                      </div>
                      <div className="mos-value">{stockData?.mosPer}%</div>
                      <div className="mos-text mt-12 text-center">
                        This stock has an MOS of{" "}
                        <span>{stockData?.mosPer}%</span>.
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default SummaryChart;
